import type { Api } from '@pflegenavi/shared-frontend/platform';
import {
  get,
  getNursingHomeBaseUrl,
} from '@pflegenavi/shared-frontend/platform';
import type { Tenant } from '@pflegenavi/frontend/tenant';
import type { AuthenticationContext } from '@pflegenavi/frontend/authentication';
import type {
  ServiceProviderAppControllerQueryTypes,
  ServiceProviderAppControllerResultTypes,
} from '@pflegenavi/service-provider-shared/api-endpoints';
import { ServiceProviderAppControllerDefinition } from '@pflegenavi/service-provider-shared/api-endpoints';

export interface IServiceProviderAppApi extends Api {
  getResidentList(dataIn: {
    params: ServiceProviderAppControllerQueryTypes['getResidentList'];
  }): Promise<ServiceProviderAppControllerResultTypes['getResidentList']>;
}

export class ServiceProviderAppApi implements IServiceProviderAppApi {
  getResidentList: IServiceProviderAppApi['getResidentList'];

  constructor(
    tenantId: Tenant,
    public authContext: AuthenticationContext,
    apiUrl?: string
  ) {
    this.getResidentList = get({
      authContext,
      url: (params) => {
        const query = new URLSearchParams();
        query.append('nursingHomeId', params.nursingHomeId);

        if (params.residentIds) {
          params.residentIds.forEach((residentId, index) => {
            query.append(`residentIds[${index}]`, residentId);
          });
        }

        if (params.residentStates) {
          params.residentStates.forEach((residentState, index) => {
            query.append(`residentStates[${index}]`, residentState);
          });
        }

        const queryString = query.toString();
        return `${getNursingHomeBaseUrl(params.tenant, apiUrl)}/${
          ServiceProviderAppControllerDefinition.controller
        }/${
          ServiceProviderAppControllerDefinition.endpoints.getResidentList.url
        }?${queryString}`;
      },
    });
  }
}
